import { CheckPicker, Input } from "rsuite";
import Responsive from "../../../Components/Responsive";
import styles from "./styles/informationsStyles";
import Translation from "../../../translation/translation";
import { useEffect, useState } from "react";
import { APi } from "../../../Api";

const MainInformations = ({ model, setModel }) => {
  const handleInputChange = (key, value, parseFunction) => {
    setModel((prev) => {
      return { ...prev, [key]: parseFunction ? parseFunction(value) : value };
    });
  };
  const [categories, setCategories] = useState([]);
  const handleNumericInputChange = (key, value, parseFunction) => {
    const parsedValue = parseFunction(value);
    if (parsedValue >= 0) {
      handleInputChange(key, value, parseFunction);
    }
  };
  const fetchCategories = () => {
    APi.createAPIEndpoint(`${APi.ENDPOINTS.Category}/GetFiltreData`, { isUmrah: true })
      .fetchAll()
      .then((res) => {
        setCategories(res.data.categories);
      })
      .catch((e) => {
        console.log("e", e);
      });
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  const handleChangeCategories=
  (categories) => {
    {
      handleInputChange("categoryIds", categories)
    }
}

  return (
    <div style={styles.mainInformations}>
      <div style={styles.subMain}>
        <Responsive m={6} l={6} xl={6} className="p-10">
          <label>Nom : </label>
          <Input
            value={model.name}
            onChange={(name) => handleInputChange("name", name.toUpperCase())}
          />
        </Responsive>

        <Responsive s={4} m={3} l={2} xl={2} className="p-10">
          <label>Commission : </label>
          <Input
            type="number"
            step="0.1"
            min="0"
            value={model.commission}
            onChange={(commission) =>
              handleNumericInputChange("commission", commission, parseFloat)
            }
          />
        </Responsive>

        <Responsive s={4} m={3} l={2} xl={2} className="p-10">
          <label>Commission B2B : </label>
          <Input
            type="number"
            step="0.1"
            value={model.b2Bcommission}
            onChange={(b2Bcommission) =>
              handleNumericInputChange(
                "b2Bcommission",
                b2Bcommission,
                parseFloat
              )
            }
          />
        </Responsive>

        <Responsive s={4} m={3} l={2} xl={2} className="p-10">
          <label>Nbre pour une gratuité : </label>
          <Input
            type="number"
            step="1"
            min="0"
            value={model.nbr_for_free_place}
            onChange={(nbr) =>
              handleNumericInputChange("nbr_for_free_place", nbr, parseInt)
            }
          />
        </Responsive>
        <Responsive s={4} m={3} l={2} xl={2} className="p-10">
          <label>{Translation.categories} :</label>
          <div className="p-2 font-sans">
            <CheckPicker
          value={model.categoryIds|| []}
          data={categories.map((c) => ({ label: c.name, value: c.id }))}
          block
          noSearch
          onChange={handleChangeCategories}
          placeholder= {Translation.chooseCategories}
        />
          </div>
        </Responsive>
      </div>

      <Responsive l={12} xl={12} m={12} className="p-5">
        <label>{Translation.description} : </label>
        <Input
          as="textarea"
          rows={4}
          block
          name="description"
          value={model.description || ""}
          onChange={(description) =>
            handleInputChange("description", description)
          }
        />
      </Responsive>
    </div>
  );
};

export default MainInformations;
